// extracted by mini-css-extract-plugin
module.exports = {"Back":"Assignment_Back__2Bws3","fadeIn":"Assignment_fadeIn__3kFig","modalFadeIn":"Assignment_modalFadeIn__2nZ_a","slideInFromRight":"Assignment_slideInFromRight__1W4CH"};